<template>
    <div
        class="dropdown"
        :class="{'is-active': isDropdownActive}"
        ref="menu_container"
        id="menu_container"
    >
        <create-button
            class="card test-card add-test-question-card dropdown-trigger"
            :is-disabled="isAnyRequestInProgress"
            :is-in-progress="requestsProgress.question.store"
            :click-handler="toggleDropdown"
        />
        <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content p-0" ref="menu" :style="menuStyles">
                <div v-for="type of questionTypes">
                    <a class="dropdown-item" @click="createQuestionClickHandler(type)">
                        {{ getQuestionTypeTranslation(type)  }}
                    </a>
                    <hr class="dropdown-divider m-0">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CreateButton from "../../../../utils/CreateButton";
import {mapActions, mapGetters} from "vuex";
export default {
name: "QuestionCreateButton",
    components: {CreateButton},
    data() {
        return {
            isDropdownActive: false,
            clickPositionX: 0,
            clickPositionY: 0,
        };
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
            'requestsProgress',
            'isAnyRequestInProgress',
            'testBeingEdited',
            'testEditor',
        ]),
        questionTypes() {
            return this.testEditor.parameters.question_types ?? [];
        },
        menuStyles() {
            const menuContainerWidth = this.$refs.menu_container ? this.$refs.menu_container.offsetWidth : 0;
            const menuContainerHeight = this.$refs.menu_container ? this.$refs.menu_container.offsetHeight : 0;
            const menuItemsWidth = this.$refs.menu ? this.$refs.menu.offsetWidth : 0;
            const menuItemsHeight = this.$refs.menu ? this.$refs.menu.offsetHeight : 0;

            const isTop = (this.clickPositionY + menuItemsHeight) < menuContainerHeight;
            const isLeft = (this.clickPositionX + menuItemsWidth) < menuContainerWidth;
            const xParameter = isLeft ? "left" : "right";
            const yParameter = isTop ? "top" : "bottom";

            const xPosition = isLeft ? this.clickPositionX : menuContainerWidth - this.clickPositionX;
            const yPosition = isTop ? this.clickPositionY : menuContainerHeight - this.clickPositionY;

            let styles = {};
            styles[xParameter] = xPosition + "px";
            styles[yParameter] = yPosition + "px";

            return styles;
        }
    },
    methods: {
        ...mapActions('tests', [
            'createTestQuestion'
        ]),
        toggleDropdown(e) {
            this.clickPositionX = e ? e.offsetX : 0;
            this.clickPositionY = e ? e.offsetY : 0;
            this.isDropdownActive = !this.isDropdownActive;

            if (this.isDropdownActive) {
                document.addEventListener("click", this.clickHandler);
            } else {
                document.removeEventListener("click", this.clickHandler);
            }
        },
        getQuestionTypeTranslation(type) {
            return this.trans.edit_form.question_types[type.code] ?? type.code;
        },
        createQuestionClickHandler(type) {
            this.createTestQuestion(type);
            this.toggleDropdown();
        },
        clickHandler(e) {
            const menuContainer = document.querySelector('#menu_container');

            const withinBoundaries = e.composedPath().includes(menuContainer);

            if (!withinBoundaries) {
                this.toggleDropdown();
            }
        }
    }
}
</script>

<style scoped lang="scss">
.add-test-question-card {
    height: 70px !important;
}

.dropdown {
    width: 100%;
    position: relative;

    .dropdown-menu {
        min-width: 0rem;
        padding-top: 0px;
    }
    .dropdown-content {
        position: absolute;
        pointer-events: all;
    }
}

.bulma .dropdown-menu {
    display: block;
    visibility: hidden;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    pointer-events: none;
}

.bulma .dropdown.is-active .dropdown-menu {
    visibility: visible;
}
</style>
